var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-img',{staticClass:"shrink cursor-pointer",staticStyle:{"border-radius":"20px"},attrs:{"alt":`${_vm.partnerSettings.partnerName}_Logo`,"contain":"","src":_vm.partnerSettings.logoUrl,"transition":"scale-transition","width":_vm.width}})
}
var staticRenderFns = []

export { render, staticRenderFns }